import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import undefined from '~/components/page/undefined.vue'
import type { Path } from '~/types/util'

export default class IsSupportHoursNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    // TODO: this is not currently used but needs to be reimplemented,
    // either DecisionNodes need to be async or we need a blocking call to the content

    return this.yesNo(true)
  }
}
